interface McpServerIconLookupInput {
  serverName?: string
  title?: string
  url?: string
  repositoryUrl?: string
}

const MCP_SERVER_ICON_PATHS: Record<string, string> = {
  webtools: '/img/mcp-servers/webtools.svg',
  github: '/img/mcp-servers/github.svg',
  alphavantage: '/img/mcp-servers/alphavantage.png',
  'helper-tools': '/img/mcp-servers/helper-tools.svg',
  etherscan: '/img/mcp-servers/etherscan.png',
  rss: '/img/mcp-servers/rss.svg',
  gdelt: '/img/mcp-servers/gdelt.png',
  thorchain: '/img/mcp-servers/thorchain.png',
  'ethereum-rpc': '/img/mcp-servers/ethereum-rpc.png',
  ethereum: '/img/mcp-servers/ethereum-rpc.png',
  'base-rpc': '/img/mcp-servers/base-rpc.png',
  base: '/img/mcp-servers/base-rpc.png',
  missionsquad: '/img/mcp-servers/missionsquad.png',
  shopify: '/img/mcp-servers/shopify.png',
  'make-com': '/img/mcp-servers/make-com.png',
  make: '/img/mcp-servers/make-com.png',
  'make.com': '/img/mcp-servers/make-com.png',
  supabase: '/img/mcp-servers/supabase.png',
  wrike: '/img/mcp-servers/wrike.png',
  notion: '/img/mcp-servers/notion.svg',
  stripe: '/img/mcp-servers/stripe.png',
  pipedream: '/img/mcp-servers/pipedream.png',
  'monday-com': '/img/mcp-servers/monday-com.png',
  monday: '/img/mcp-servers/monday.png',
  'monday.com': '/img/mcp-servers/monday-com.png',
  'cloudflare-api': '/img/mcp-servers/cloudflare-api-official.png',
  cloudflare: '/img/mcp-servers/cloudflare-api-official.png',
  audioscrape: '/img/mcp-servers/audioscrape.png',
  asana: '/img/mcp-servers/asana.png',
  coingecko: '/img/mcp-servers/coingecko.png',
  deepwiki: '/img/mcp-servers/deepwiki.png',
  dropbox: '/img/mcp-servers/dropbox.png',
  wix: '/img/mcp-servers/wix.svg',
  amplitude: '/img/mcp-servers/amplitude.png',
  neon: '/img/mcp-servers/neon.png',
  prisma: '/img/mcp-servers/prisma.svg',
  calendly: '/img/mcp-servers/calendly.png',
  cloudinary: '/img/mcp-servers/cloudinary.png',
  beehiiv: '/img/mcp-servers/beehiiv.png',
  netlify: '/img/mcp-servers/netlify.png',
  'google-workspace': '/img/mcp-servers/google-workspace.svg',
  google: '/img/mcp-servers/google-workspace.svg',
  context7: '/img/mcp-servers/context7.png',
  grok: '/img/mcp-servers/grok.png',
  gamma: '/img/mcp-servers/gamma.png',
  slack: '/img/mcp-servers/slack.png',
  wordpress: '/img/mcp-servers/wordpress.svg',
  bitly: '/img/mcp-servers/bitly.png',
  klaviyo: '/img/mcp-servers/klaviyo.png',
  'klaviyo-external': '/img/mcp-servers/klaviyo-external.png',
  news: '/img/mcp-servers/news.svg',
  apify: '/img/mcp-servers/apify.svg',
  granola: '/img/mcp-servers/granola.png',
  miro: '/img/mcp-servers/miro.png',
  postman: '/img/mcp-servers/postman.png',
  vercel: '/img/mcp-servers/vercel.png',
  webflow: '/img/mcp-servers/webflow.png',
  zapier: '/img/mcp-servers/zapier.png',
  atlassian: '/img/mcp-servers/atlassian.png',
  canva: '/img/mcp-servers/canva.png'
}

export function getMcpServerIconPath(input: McpServerIconLookupInput): string | null {
  const candidates = buildLookupCandidates(input)

  for (const candidate of candidates) {
    const iconPath = MCP_SERVER_ICON_PATHS[candidate]
    if (iconPath) {
      return iconPath
    }
  }

  return null
}

function buildLookupCandidates(input: McpServerIconLookupInput): string[] {
  const candidates = new Set<string>()

  addNormalizedCandidate(candidates, input.serverName)
  addNormalizedCandidate(candidates, input.title)

  for (const hostname of [extractHostname(input.url), extractHostname(input.repositoryUrl)]) {
    if (!hostname) {
      continue
    }

    addNormalizedCandidate(candidates, hostname)

    const hostnameWithoutCommonPrefixes = hostname
      .replace(/^mcp\./, '')
      .replace(/^api\./, '')
      .replace(/^www\./, '')

    addNormalizedCandidate(candidates, hostnameWithoutCommonPrefixes)

    const firstSegment = hostnameWithoutCommonPrefixes.split('.')[0]
    addNormalizedCandidate(candidates, firstSegment)
  }

  return Array.from(candidates)
}

function addNormalizedCandidate(target: Set<string>, value: string | undefined): void {
  if (!value) {
    return
  }

  const normalized = normalizeLookupToken(value)
  if (normalized) {
    target.add(normalized)
  }
}

function normalizeLookupToken(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase()
    .replace(/[_\s]+/g, '-')
    .replace(/[^a-z0-9.-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

function extractHostname(value: string | undefined): string | undefined {
  if (!value) {
    return undefined
  }

  try {
    return new URL(value).hostname
  } catch {
    return undefined
  }
}
